import { Dispatch } from 'redux'

export const CLEAR_ASSETS = 'CLEAR_ASSETS'

export const clearAssets = (dispatch: Dispatch) => {
  dispatch({ type: CLEAR_ASSETS })
}
